
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonalDetailsRequest, PersonalDetailsResponse, AddressResponse, NumberOfAttempts, UserAccountStatus } from './contracts/personal-details';
import { CityPincodeMapping } from './contracts/personal-details';
import { BackendService } from '../../backend.service';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ApplicationService } from '../../application/application.service';
import { TokenService } from '../../token/token.service';
import { PDRequest } from './contracts';

@Injectable()
export class PersonalDetailsService {

  private getPersonalDetailsUrl = '/PersonalDetails/SocialDetails/{customerId}';
  private getPersonalDetailsV2Url = '/PersonalDetails/CustomerDetails/v2/SocialDetails/{customerId}?withContact=true';
  private savePersonalDetailsUrl = '/PersonalDetails/CustomerDetails/v2/SocialDetails';
  private MerchantDataUrl = '/ApplicationFlow/LoanApplications/{loanApplicationId}/Customer/PersonalDetails';
  private getTemporaryAadhaarUrl = '/PersonalDetails/customers/{customerId}/aadhaar';
  private getCityFromPincodeUrl = '/utility/pincode/{pincode}/locality';
  private getAddressUrl = '/PersonalDetails/Customers/{customerId}/Addresses';
  private blockUserTemporarilyUrl = '/users/{customerId}/status';
  private getPincodeInfoUrl = '/utility/pincode/{pincode}/details';
  private getComplianceConsentUrl = '/customer-details/api/v1/consent/customers/{customerId}';
  private saveComplianceConsentUrl = '/customer-details/api/v2/consent/customers/{customerId}';

  constructor(private backendService: BackendService, private tokenService: TokenService, private applicationService: ApplicationService) { }

  getPersonalDetailsV1(): Observable<PersonalDetailsRequest> {
    return this.backendService.getData(this.getPersonalDetailsUrl);
  }
  getPersonalDetailsV2(): Observable<PersonalDetailsResponse> {
    let getPersonalDetailsV2Url = this.getPersonalDetailsV2Url;
    if (this.applicationService.getApplicationId()) {
      getPersonalDetailsV2Url += '&applicationId=' + this.applicationService.getApplicationId();
    }
    const merchantcustomerId = this.tokenService.getMerchantCustomerId();
    if (merchantcustomerId) {
      getPersonalDetailsV2Url = getPersonalDetailsV2Url + '&merchantcustomerId=' + merchantcustomerId;
    }
    return this.backendService.getData(getPersonalDetailsV2Url);
  }
  savePersonalDetails(personalDetailsRequest: PersonalDetailsRequest | PDRequest) {
    return this.backendService.setData(this.savePersonalDetailsUrl, personalDetailsRequest);
  }
  getFromMerchant(loanApplicationId: string): Observable<PersonalDetailsRequest> {
    return this.backendService.getData(this.MerchantDataUrl.replace('{loanApplicationId}', loanApplicationId));
  }
  getTemporaryAadhaar(): Observable<any> {
    return this.backendService.getData(this.getTemporaryAadhaarUrl);
  }
  getCityFromPincode(pincode: string): Observable<CityPincodeMapping> {
    return this.backendService.getData(this.getCityFromPincodeUrl.replace('{pincode}', pincode));
  }
  getAddress(): Observable<AddressResponse[]> {
    return this.backendService.getData(this.getAddressUrl);
  }
  setBlockUserStatus(attempts: NumberOfAttempts): Observable<any> {
    const action = {
      'Action': 'block',
      'Reasons': `Remaining attempts for Aadhaar: ${attempts.aadhaar} and PAN: ${attempts.pan}`
    };
    return this.backendService.setData(this.blockUserTemporarilyUrl, action, null, false, false, false, true);
  }
  getBlockUserStatus(): Observable<UserAccountStatus> {
    return this.backendService.getData(this.blockUserTemporarilyUrl, null, false, false, false, false, false, true);
  }
  getPincodeInfo(pincode: string): Observable<any> {
    return this.backendService.getData(this.getPincodeInfoUrl.replace('{pincode}', pincode));
  }
  getComplianceConsent(): Observable<any> {
    return this.backendService.getData(this.getComplianceConsentUrl);
  }
  saveComplianceConsent(consentType: string): Observable<any> {
    const data = {
      consents: [{
        'consentType': consentType,
        'isAccepted': true,
        'source': 'preapprove'
      }]
    };
    return this.backendService.putData(this.saveComplianceConsentUrl, data);
  }
}

@Injectable()
export class PersonalDetailsResolveService implements Resolve<PersonalDetailsResponse> {
  constructor(private personalDetailsService: PersonalDetailsService) { }
  resolve(route: ActivatedRouteSnapshot): Promise<PersonalDetailsResponse> {
    return new Promise((resolve, reject) => {
      this.personalDetailsService.getPersonalDetailsV2().subscribe(response => {
        resolve(response);
      }, error => {
        resolve(null);
      });
    });
  }
}
